import styled, { css } from 'styled-components';
import { TextareaProps } from './Textarea.types';

const getDisabledStyles = () => css`
  background-color: ${(props) => props.theme.brand.background.disabled};
  border-color: #d9d9d9;
  color: #999999;

  ::placeholder {
    color: #999999;
  }

  &:focus {
    border-color: ${(props) => props.theme.brand.text.disabled};
  }
`;
const getErrorStyles = () => {
  const colorError = '#CC2324';
  return css`
    border-color: ${colorError};
    color: ${colorError};

    ::placeholder {
      color: ${colorError};
    }

    &:focus {
      border-color: ${colorError};
    }
  `;
};

const Textarea = styled.textarea<TextareaProps>((props) => {
  const { hasError, disabled } = props;
  const { background, color, borderRadius, borderColor, lineHeight } =
    props.theme.components.textarea.base;

  return css`
    width: 100%;
    padding: 8px 16px;
    font: inherit;
    background: ${background};
    border: 1px solid ${borderColor};
    border-radius: ${borderRadius};
    color: ${color};
    outline: none;
    resize: ${props.resize};
    line-height: ${lineHeight};
    -webkit-appearance: none;

    ::placeholder {
      color: #999999;
    }

    &:focus {
      border-color: ${(props) => props.theme.brand.primary.base};
    }

    ${hasError && getErrorStyles()}
    ${disabled && getDisabledStyles()}
  `;
});

export { Textarea };
